import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoginInfoHelper } from 'src/app/helpers/login-info-helper';
import { Training } from 'src/app/models/training.model';
import { TrainingService } from 'src/app/services/training.service';
import { InfoDialogComponent } from '../dialogs/info-dialog/info-dialog.component';
import { PopupHelper } from 'src/app/helpers/pop-up-helper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InfoPopUpComponent } from '../pop-ups/info-pop-up/info-pop-up.component';
import { SubmitDialogComponent } from '../dialogs/submit-dialog/submit-dialog.component';
import { CourseService } from 'src/app/services/course.service';
import { TranslateService } from '@ngx-translate/core';
import { WorkspaceService } from 'src/app/services/workspace.service';
import { MatCardModule } from '@angular/material/card';
import { Course } from 'src/app/models/course.model';

@Component({
  selector: 'kwconnect-training-view',
  templateUrl: './kwconnect-training-view.component.html',
  styleUrls: ['./kwconnect-training-view.component.scss']
})
export class KWConnectTrainingViewComponent implements OnInit {
  public trainingCreating = false;
  public trainingRestarting = false;
  public userHasTraining = false;
  public multipleTrainings = false;
  public userMail: string;
  public trainingInfo: Training;
  public trainingsForUser: Training[];
  public courseIdNew: string;
  public trainingCreated = false;
  public showTrainingInfo = false;
  public stoppingTraining = false;
  public creatingTraining = false;
  public showCourseInfo = false;
  public registrationCode;
  public courseExists = false;
  public subscriptionValid;
  public subscriptionEnd: Date;
  public subscriptionStart: Date;
  public currentCourse: Course;

  constructor(public loginLoginInfoHelper: LoginInfoHelper,
              private trainingService: TrainingService,
              private courseService: CourseService,
              private dialog: MatDialog,
              private popUp: MatSnackBar,
              private popUpHelper: PopupHelper,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private translateService: TranslateService,
              private workspaceService: WorkspaceService
            ) {
            this.translateService.addLangs(['en', 'de']);
            this.translateService.setDefaultLang('en');
            const browser = (translateService.getBrowserCultureLang() || 'en').toLowerCase();
            const lang = browser.startsWith('de') ? 'de' : 'en';
            translateService.use(lang);
            this.initializeAndCreateTraining();
            this.userMail = this.loginLoginInfoHelper.getLoginUserFromStorage().mail;
  }
  
  ngOnInit(): void {
  }

  restartTraining() {
    this.trainingRestarting = true;
    if (!this.trainingInfo || !this.checkSubsription() || this.multipleTrainings) {
      this.trainingRestarting = false;
      return;
    }
    
    this.trainingInfo.course.courseID = this.courseIdNew;
    this.userHasTraining = false;
    this.trainingService.restartTraining(this.trainingInfo).subscribe(
      (data) => {
        this.userHasTraining = true;  
        this.trainingRestarting = false;
        
        this.userHasTraining = true;
        this.trainingCreated = true;  
      },
      (err) => {
        this.trainingRestarting = false;
      }
    );
  }

  public async initializeAndCreateTraining(): Promise<void> {
    try {
      // Await the execution of each method
      await this.getKWConnectAttributes();
      if (this.checkSubsription()) {
        await this.loadCourseIdFromParam();
        await this.checkTraining();
        if(!this.userHasTraining && this.courseExists && this.checkSubsription()) {
          this.createTraining();
        }
        this.getRegistrationCode();        
      }
      // Once all are completed, call createTraining
    } catch (error) {
    }
  }

  private checkTraining() : Promise<void> {
    return new Promise((resolve, reject) => {
      this.trainingService.getTrainingsByLoginUser().subscribe(
        (data) => {
          if (data.length == 0) {
            this.userHasTraining = false;
          } else if(data.length > 1)  {
            this.trainingsForUser = data;
            this.multipleTrainings = true;
          } else  {
            // this.courseIdNew = data[0].course.courseName;
            this.userHasTraining = true;
            this.trainingInfo = data[0];
          }
          resolve(); 
        },
        (error) => {
          this.trainingCreating = false;
      
          // this.translateService.get('TRAINING.ERROR_FETCHING_TRAINING').subscribe((res) => {
          //   const message: string = res;
          //   this.showErrorMessage(message);
          // })
          reject(error);
        }
      )
    });
  }

  stopTraining() { 
    const separator = "|";
    const courseID = this.trainingInfo.course.courseID
    this.translateService.get('TRAINING.DELETE_TRAINING_DIALOG',{value: courseID}).subscribe((res) => {
      const title_message = new String(res).split(separator);
      const dialogRef = this.openSubmitDialog(
        title_message[0],
        title_message[1]);
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.translateService.get('TRAINING.IS_AVAILABLE.DELETING_TRAINING').subscribe((deleting) => {
            const deletingString = new String(deleting);
            this.stoppingTraining = true;

            this.translateService.get('TRAINING.DELETE_TRAINING').subscribe((mes) => {
            const success_failure = new String(mes).split(separator);
            this.trainingService.deleteTraining(this.trainingInfo).subscribe(
              (data) => {
                this.userHasTraining = false;
                this.stoppingTraining = false;
                this.trainingInfo = null;
                this.showCourseInfo = false;
                this.loadCourseIdFromParam();
              },
              (error) => {
                this.popUp.dismiss();
                this.trainingCreating = false;
                this.stoppingTraining = false;
                // this.showErrorMessage(success_failure[1] + ": " +  error.error);
                this.loadCourseIdFromParam();
              }
            );
          });
        });
      }
    });
  })
}

  
  private openSubmitDialog(title: string, message: string): MatDialogRef<SubmitDialogComponent, any> {
    return this.dialog.open(SubmitDialogComponent, {
        width: '450px',
        data: { title, message }
    });
  }


  private loadCourseIdFromParam(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.activatedRoute.queryParamMap.subscribe(
        async (params) => {
          this.courseIdNew = params.get("courseId");
          await this.checkIfCourseExists(); // Assuming this is synchronous or already returns a promise
          resolve(); // Resolve once the course ID is loaded and checkIfCourseExists() is called
        },
        (error) => {
          this.translateService.get('TRAINING.COURSE.NOT_LOADED').subscribe((mes) => {
            reject(error); // Reject the promise in case of an error
          });
        }
      );
    });
  }

  public createTraining() {
    this.trainingCreating = true;
    this.showTrainingInfo = true;

    this.trainingService.createKWConnectTraining(this.courseIdNew).subscribe(
      (data) => {
        
        this.trainingCreating = false;
        this.trainingInfo = data
        this.userHasTraining = true;
        this.trainingCreated = true;  
        // this.popUpHelper.showPopUp("Notification has been sent to email: " + this.userMail);
      },
      (error) => {
        this.trainingCreating = false;
      
      }
    )

  }

  toggleShowCourseInfo() {
    this.showCourseInfo = !this.showCourseInfo;
  }

  private async prepareKWConnect() {
    try {
      await this.getKWConnectAttributes();
    } catch {
        
    }
  }

  openWorkspaceWebpage(registrationCode: string) {
    window.open("https://webclient.amazonworkspaces.com/?registrationCode=" + this.registrationCode, "_blank");
  }

  showErrorMessage(message: string) {
    this.dialog.open(InfoDialogComponent, {
      width: '450px',
      data: { "title" : "Error", "message": message},
    });
  }
  
  showSnackBar(translationValue: string) {
    this.translateService.get(translationValue).subscribe((res) => {
      const message = new String(res);
      this.popUp.openFromComponent(InfoPopUpComponent, {
        data: { message },
        duration: 5000
      });
    });
  }


  private checkIfCourseExists(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.courseService.getCourse(this.courseIdNew).subscribe(
        (data) => {
          this.currentCourse = data;
          this.courseExists = true;
          resolve(); // Resolve the promise when the course is found
        },
        (error) => {
          this.courseExists = false;
        }
      );
    });
  }

  changeLanguage(locale: string) {
    if (!locale) {
      return;
    }
    this.translateService.use(locale);
  }

  getTooltip() {
    this.translateService.get('TRAINING.IS_AVAILABLE.COPY_TO_CLIPBOARD').subscribe((res) => {
      return new String(res);
    });
  }

  private getKWConnectAttributes(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const subscriptionValidKey = "kwtrain_subscription_valid";
      const subscriptionEndKey = "kwtrain_subscription_end";
      const subscriptionStartKey = "kwtrain_subscription_start";
      
      this.trainingService.getKWConnectKeycloakAttributes().subscribe(
        (data) => {
          // Set the subscription data once it's received
          this.subscriptionValid = data[subscriptionValidKey];
          this.subscriptionStart = data[subscriptionStartKey];
          this.subscriptionEnd = data[subscriptionEndKey];
          resolve(); // Resolve the promise after the data is set
        },
        (error) => {
          // If there's an error, reject the promise and display the error message
        }
      );
    });
  }

  getRegistrationCode() {
      this.workspaceService.getDirectoryInfo().subscribe(
        (data) => {
            this.registrationCode = data.registrationCode;
        }, 
        (error) => {
        }
      )
  }

  checkSubsription() {
    return this.subscriptionValid !== null && this.subscriptionValid === 'true';
  }

  areKeycloakParamsSet() {
    return this.subscriptionEnd !== null && this.subscriptionStart !== null && this.subscriptionValid !== null;
  }

  closeTab() {
    window.close();
  }
}